import React, { createContext, useContext, useReducer } from 'react';

// reducers
import { globalReducer } from 'shared/state/reducers';

const initialState = {
    auth: {
        user: {}
    }
};

export const StateContext = createContext();

export const StateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(globalReducer, initialState);

    return <StateContext.Provider value={ { state, dispatch } }>
        { children }
    </StateContext.Provider>
};

export const useStore = () => useContext(StateContext);

export const useStateValue = () => {
    const { state } = useContext(StateContext);
    return state;
}

export const useDispatch = () => {
    const { dispatch } = useContext(StateContext);
    return dispatch;
}

export const useAuthUser = () => {
    const { state: { auth } } = useContext(StateContext);
    return auth;
}
